import { SlotFillType } from './types';

import { SelectItem } from '@/components/select/types';

export const typeItems: SelectItem<SlotFillType>[] = [
    {
        id: 'schedule',
        value: 'Работа в клинике'
    },
    {
        id: 'vacation',
        value: 'Отпуск',
    },
]